var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"partner-directory mt-2"},[_c('CRow',[_c('CCol',{attrs:{"md":"3"}},[_c('DirectoryFilter',{on:{"filterAction":_vm.filterAction}})],1),_c('CCol',{attrs:{"md":"9"}},[_c('DirectoryList',{attrs:{"filterData":_vm.filterValue}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }